import React from 'react'
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { ChartContainer, SectionTitle } from '../styles'
import { getSeriesColor, mergeSeriesToChartData } from '../utils'

const SeriesChart = ({ title, series = {}, height = '320px' }) => {
    const keys = Object.keys(series || {})
    const data = mergeSeriesToChartData(series)

    if (!keys.length || !data.length) {
        return (
            <ChartContainer $height='120px'>
                {title && <SectionTitle>{title}</SectionTitle>}
                <div style={{ color: 'var(--text-tertiary)', fontSize: 14 }}>Sem dados no período.</div>
            </ChartContainer>
        )
    }

    return (
        <ChartContainer $height={height}>
            {title && <SectionTitle>{title}</SectionTitle>}
            <div style={{ flex: 1, minHeight: 0 }}>
                <ResponsiveContainer width='100%' height='100%'>
                    <LineChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                        <CartesianGrid stroke='#f0f0f0' />
                        <XAxis dataKey='label' tick={{ fontSize: 11 }} />
                        <YAxis tick={{ fontSize: 11 }} />
                        <Tooltip />
                        <Legend />
                        {keys.map((key, index) => (
                            <Line
                                key={key}
                                type='monotone'
                                dataKey={key}
                                name={key.replace(/_/g, ' ')}
                                stroke={getSeriesColor(index)}
                                strokeWidth={2}
                                dot={false}
                            />
                        ))}
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </ChartContainer>
    )
}

export const SingleSeriesChart = ({ title, points = [], dataKey = 'value', height = '280px' }) => {
    const series = { [dataKey]: points || [] }
    return <SeriesChart title={title} series={series} height={height} />
}

export default SeriesChart
